import { create } from 'zustand'
import { translations, type Language } from './translations'

export type { Language }
export { languageNames } from './translations'

interface LanguageState {
  language: Language
  setLanguage: (lang: Language) => void
}

export const useLanguageStore = create<LanguageState>((set) => ({
  language: (localStorage.getItem('synapsios_lang') as Language) || 'en',
  setLanguage: (lang: Language) => {
    localStorage.setItem('synapsios_lang', lang)
    set({ language: lang })
  },
}))

export function useT() {
  const language = useLanguageStore(s => s.language)
  return translations[language]
}
